<template>
    <div class="flex" :class="{ 'flex-wrap': isMobile }">

        <div class="d-flex flex-row edit-options-btns mr-4" :class="{ 'mb-2': isMobile }">
            <label v-if="!editData?.id && testArr" for="file-upload" class="cursor-pointer"
                @click="toggleGrayActiveButton('text')">
                <div class="editor-btn editor-btn__left hover:bg-[var(--editor-btn-hover-color)]"
                    :class="{ 'is-active-gray': isGrayActiveButton === 'imput' }">
                    <img src="/icon/editor/photo.svg" alt="" class="w-[32px] icons-color-filter" />
                    <input id="file-upload" class="file-input hidden" type="file" @change="uploadImage" multiple />
                </div>
            </label>

            <div class="editor-btn editor-btn__right hover:bg-[var(--editor-btn-hover-color)] cursor-pointer"
                :class="{ 'is-active-gray': isGrayActiveButton === 'text' }"
                v-on:click="[toggleGrayActiveButton('text'), showMenuTooltip()]">
                <img src="/icon/editor/format.svg" class="w-[32px] icons-color-filter" alt="" />
            </div>
        </div>

        <div class="menu--tooltip tiptap-menu" :class="{ 'active': isShowMenuTooltip }">
            <div class="flex flex-row w-[100%] tiptap-menu-container">
                <div class="editor-buttons-set">
                    <div class="editor-btn editor-btn__left mr-[1px] hover:bg-[var(--editor-btn-hover-color)]"
                        @click="editor.chain().focus().toggleBold().run()"
                        :disabled="!editor.can().chain().focus().toggleBold().run()"
                        :class="{ 'is-active__green': editor?.isActive('bold') }">
                        <img class="w-50 h-50 icons-color-filter" src="/icon/editor/bold.svg" alt="" />
                    </div>
                    <div class="editor-btn editor-btn__right hover:bg-[var(--editor-btn-hover-color)]"
                        @click="editor.chain().focus().toggleItalic().run()"
                        :disabled="!editor.can().chain().focus().toggleItalic().run()"
                        :class="{ 'is-active__green': editor?.isActive('italic') }">
                        <img src="/icon/editor/italic.svg" class="icons-color-filter" alt="" />
                    </div>
                </div>

                <div class="editor-buttons-set">
                    <div class="editor-btn editor-btn__left mr-[1px] hover:bg-[var(--editor-btn-hover-color)]"
                        @click="editor.chain().focus().toggleOrderedList().run()"
                        :class="{ 'is-active__green': editor?.isActive('orderedList') }">
                        <img src="/icon/editor/list_numbered.svg" class="icons-color-filter" alt="Numbered List" />
                    </div>
                    <div class="editor-btn editor-btn__right hover:bg-[var(--editor-btn-hover-color)]"
                        @click="editor.chain().focus().toggleBulletList().run()"
                        :class="{ 'is-active__green': editor?.isActive('bulletList') }">
                        <img src="/icon/editor/bulleted.svg" class="icons-color-filter" alt="Bullet List" />
                    </div>
                </div>

                <div class="editor-buttons-set">
                    <div class="editor-btn editor-btn__left mr-[1px] hover:bg-[var(--editor-btn-hover-color)]"
                        @click="editor.chain().focus().unsetBlockquote().run()"
                        :disabled="!editor?.can().unsetBlockquote()">
                        <img src="/icon/editor/indent_decrease.svg" class="icons-color-filter" alt="" />
                    </div>
                    <div class="editor-btn editor-btn__right hover:bg-[var(--editor-btn-hover-color)]"
                        @click="editor.chain().focus().setBlockquote().run()" :disabled="!editor.can().setBlockquote()">
                        <img src="/icon/editor/indent_increase.svg" class="icons-color-filter" alt="" />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import {
  defineEmits,
  defineProps,
  ref,
} from 'vue';

const props = defineProps({
    isGrayActiveButton: String,
    editData: Object,
    testArr: Array,
    editor: {
        type: Object,
        required: true,
        default: () => ({}),
    },
    isShowMenuTooltip: Boolean,
});

const fileInput = ref(null);
const isMobile = ref(window.innerWidth < 1023);
const tooltipStyle = ref({
    left: '20px',
    bottom: '126px',
});

const emit = defineEmits(['toggle-gray-active-button', 'upload-image', 'show-menu-tooltip']);

const toggleGrayActiveButton = (button) => {
    emit('toggle-gray-active-button', button);
};

const uploadImage = (event) => {
    emit('upload-image', event);
};

const showMenuTooltip = () => {
    emit('show-menu-tooltip');
};
</script>

<style lang="scss" scoped>
/* editor-buttons.scss */
.editor-btn {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 5px;
    cursor: pointer;

    &__left {
        margin-right: 2px;
    }

    &__right {
        margin-left: 2px;
    }

    &.is-active-gray {
        background: var(--editor-btn-hover-color);
    }
}

/* tiptap-menu.scss */
.tiptap-menu {
    padding: 0px;
    background: transparent;

    button {
        border: 2px solid rgb(216, 180, 254);
        padding: 3px;
        border-radius: 6px;
        margin: 2px 4px;
        padding: 0 5px;
        color: #FFF;
        font-weight: 400 !important;
        font-size: 12px;

        &.is-active {
            background: green;
        }
    }

    .btn-upload-img {
        max-width: fit-content;
        display: inline-block;
        border: 2px solid rgb(216, 180, 254);
        padding: 3px;
        border-radius: 6px;
        margin: 2px 4px;
        padding: 0 5px;
        color: #FFF;
        font-weight: 400 !important;
        font-size: 12px;

        &.is-active {
            background: green;
        }
    }
}

.menu--tooltip {
    width: auto;
    display: none;
    opacity: 0;
    transition: opacity 250ms ease-in-out, transform 250ms ease-in-out;

    &.active {
        display: flex;
        opacity: 1;
    }

    @media (max-width: 680px) {
        left: 21px;
        bottom: 173px;
    }

    @keyframes slide {
        0% {
            opacity: 0;
            transform: translate(0, 0) scale(0.1);
        }

        100% {
            opacity: 1;
            transform: translate(10%, -100%) scale(1);
        }
    }
}

@media (max-width: 680px) {
    .tiptap-menu-container {
        width: 89% !important;
    }
}

.white-filter {
    filter: brightness(0) invert(1);
}

.icons-color-filter {
    filter: var(--icons-color-filter);
}
</style>